import { Module } from 'vuex'

interface CommentaryPageState {
  isPreCommentaryFirstTimeOpendPage: boolean
  isPostCommentaryFirstTimeOpendPage: boolean
  preCommentarySelectedList: { [type: string]: number }
  postCommentarySelectedList: { [type: string]: number }
  preCommentaryList: { [type: string]: { [filter: string]: string } }
  postCommentaryList: { [type: string]: { [filter: string]: string } }
}

export const commentaryPageStateModule = (): Module<CommentaryPageState, any> => {
  return {
    namespaced: true,
    state: {
      isPreCommentaryFirstTimeOpendPage: true,
      isPostCommentaryFirstTimeOpendPage: true,
      preCommentarySelectedList: {},
      postCommentarySelectedList: {},
      preCommentaryList: {},
      postCommentaryList: {}
    },
    mutations: {
      setIsPreCommentaryFirstTimeOpendPage(state, { flag }: { flag: boolean }) {
        state.isPreCommentaryFirstTimeOpendPage = flag
      },
      setIsPostCommentaryFirstTimeOpendPage(state, { flag }: { flag: boolean }) {
        state.isPostCommentaryFirstTimeOpendPage = flag
      },
      setPreCommentarySelected(state, { type, index }: { type: string; index: number }) {
        state.preCommentarySelectedList[type] = index
      },
      setPostCommentarySelected(state, { type, index }: { type: string; index: number }) {
        state.postCommentarySelectedList[type] = index
      },
      initPreCommentarySelectedList(state) {
        state.preCommentarySelectedList = {}
      },
      initPostCommentarySelectedList(state) {
        state.postCommentarySelectedList = {}
      },
      setPreCommentary(state, { type, filter, commentary }: { type: string; filter: string; commentary: string }) {
        if (!state.preCommentaryList[type]) {
          state.preCommentaryList[type] = {}
        }
        state.preCommentaryList[type][filter] = commentary
      },
      setPostCommentary(state, { type, filter, commentary }: { type: string; filter: string; commentary: string }) {
        if (!state.postCommentaryList[type]) {
          state.postCommentaryList[type] = {}
        }
        state.postCommentaryList[type][filter] = commentary
      },
      initPreCommentaryList(state) {
        state.preCommentaryList = {}
      },
      initPostCommentaryList(state) {
        state.postCommentaryList = {}
      }
    },
    actions: {},
    getters: {
      isPreCommentaryFirstTimeOpendPage: state => state.isPreCommentaryFirstTimeOpendPage,
      isPostCommentaryFirstTimeOpendPage: state => state.isPostCommentaryFirstTimeOpendPage,
      preCommentarySelectedList: state => state.preCommentarySelectedList,
      postCommentarySelectedList: state => state.postCommentarySelectedList
    }
  }
}
